import React from 'react';
import { Link } from 'react-router-dom';
import { connectWS, MsToString } from '../../common';
import { QuizShowAdminRepository } from '../../repository/QuizShowAdminRepository';

const repository = new QuizShowAdminRepository();
const colors = ["#d50000", "#17a2b8", "#304ffe", "#2e7d32"];

class QuizAdminGamePlayerPage extends React.Component {
  constructor(props) {
    super(props);

    this.sock = undefined;

    this.state = {
      user: {},
      quizList: "[]",
      selectedQuiz: {},
      selectedQuizReportList: [],
      gameReportList: [],
      joinedUserList: [],
      solvedUserList: [],
    };
  }

  componentDidMount() {
    const { gameId } = this.props.match.params;

    repository.findMe(null, (data) => {
      this.setState({ user: data });

      repository.searchQuiz({ gameId }, (data) => {
        this.setState({ quizList: JSON.stringify(data.quizzes) });
      });

      repository.joinGame({ id: gameId }, () => {
        this.sock = connectWS(data.accountId, () => {
          window.Toast.info("접속 완료!");
        }, () => false, this.onMessageHandler);
        this.fetchGameUser(gameId);
      });
    });
  }

  componentWillUnmount() {
    this.sock && this.sock.close();
  }

  onClickNext(e) {
    e.preventDefault();
    const { quizList } = this.state;
    const quiz = JSON.parse(quizList).filter(v => !v.solved)[0];
    if (!quiz)
      return;

    repository.startQuizExam({ id: quiz.id }, () => {
      let quizListV2 = JSON.parse(quizList) || [];
      quizListV2.forEach(v => {
        v.solved = v.id === quiz.id ? true : v.solved;
      });
      this.setState({ quizList: JSON.stringify(quizListV2) });
    });
  }

  onClickEnd(e) {
    e.preventDefault();
    const { selectedQuiz } = this.state;
    selectedQuiz.quizId && repository.endQuizExam({ id: selectedQuiz.quizId });
  }

  onClickGameResult(e) {
    e.preventDefault();
    const { gameId } = this.props.match.params;
    repository.reportGame({ id: gameId }, (data) => {
      this.setState({ gameReportList: data.userGameReports });
    });
  }

  onTimeout = () => {
    repository.endQuizExam({ id: this.state.selectedQuiz.quizId });
  };

  fetchGameUser = (gameId) => {
    repository.findGameUser({ id: gameId }, (data) => {
      this.setState({ joinedUserList: data.users });
    });
  };

  onMessageHandler = (msg) => {
    const data = JSON.parse(msg.data);
    const payload = data.payload;
    const { gameId } = this.props.match.params;

    switch (data.messageType) {
      case "GAME_USER_JOINED":
        window.Toast.info(`${payload.userNickname} 접속!`);
        this.fetchGameUser(gameId);
        break;
      case "GAME_USER_LEFT":
        this.fetchGameUser(gameId);
        break;
      case "QUIZ_EXAM_START":
        this.setState({
          selectedQuizReportList: [],
          gameReportList: [],
          solvedUserList: [],
          selectedQuiz: payload
        });
        break;
      case "QUIZ_EXAM_END":
        payload.finished = true;
        this.setState({
          solvedUserList: [],
          selectedQuiz: payload
        });
        repository.reportQuiz({ id: payload.quizId }, (data) => {
          this.setState({
            selectedQuizReportList: data.userQuizSolves
          });
        });
        break;
      case "QUIZ_SOLVED":
        window.Toast.info(`${payload.userNickname} 제출!`);
        const _solvedUserList = this.state.solvedUserList;
        _solvedUserList.push(payload.userNickname);
        this.setState({
          solvedUserList: [].concat(_solvedUserList)
        });
        break;
      default:
        break;
    }
  }

  render() {
    const { gameId } = this.props.match.params;
    const { user, quizList, selectedQuiz, selectedQuizReportList, joinedUserList, solvedUserList, gameReportList } = this.state;
    const quizzes = JSON.parse(quizList) || [];

    return (
      <>
        <div style={{ display: "flex", flexDirection: "row", position: "absolute", width: "100%", height: "100%" }}>
          <div style={{ flex: 1, background: "#eee", display: "flex", flexDirection: "column" }}>
            <div style={{ flex: 1 }}>
              <QuizListWrap quizzes={quizzes} selectedQuiz={selectedQuiz} />
            </div>
            <div style={{ flex: 1 }}>
              <JoinedUserListWrap joinedUserList={joinedUserList} user={user} />
            </div>
          </div>
          <div style={{ display: "flex", flexDirection: "column", flex: 5 }}>
            <QuizPlayDisplayWrap
              gameId={gameId}
              selectedQuiz={selectedQuiz}
              selectedQuizReportList={selectedQuizReportList}
              gameReportList={gameReportList} />
          </div>
          <div style={{ flex: 1, background: "#eee", display: "flex", flexDirection: "column" }}>
            <div style={{ flex: 1 }}>
              <TimeLimitWrap
                selectedQuiz={selectedQuiz}
                onTimeout={this.onTimeout.bind(this)}
                solvedUserList={solvedUserList} />
            </div>
            <div style={{ flex: 1 }}>
              <QuizPlayControllerWrap
                onClickNext={this.onClickNext.bind(this)}
                onClickEnd={this.onClickEnd.bind(this)}
                onClickGameResult={this.onClickGameResult.bind(this)} />
            </div>
          </div>
        </div>
      </>
    );
  }
}

const QuizListWrap = (props) => {
  const { quizzes, selectedQuiz } = props;
  return (
    <>
      <div style={{ marginTop: 30 }}>
        <Link to={"/quizshow-admin"} className={"btn btn-info"}>
          <i className={"bi-arrow-90deg-left"}>&nbsp;&nbsp;</i>목록으로
        </Link>
      </div>

      <div style={{ marginTop: 30 }}>
        <span style={{ fontSize: 24 }}>{quizzes.filter(v => v.solved).length} / {quizzes.length}</span>
      </div>

      <div style={{ marginTop: 10 }}>
        <QuizAdminGamePlayerQuizSimpleList items={quizzes} selectedQuiz={selectedQuiz} />
      </div>
    </>
  );
};

const JoinedUserListWrap = (props) => {
  const { joinedUserList, user } = props;
  return (
    <>
      <div style={{ marginTop: 10 }}>
        <div style={{ fontSize: 24 }}>참가자목록</div>
      </div>
      <div style={{ marginTop: 20 }}>
        <QuizAdminGamePlayerJoinedUserList items={joinedUserList} user={user} />
      </div>
    </>
  );
};

const QuizPlayDisplayWrap = (props) => {
  const { selectedQuiz, selectedQuizReportList, gameReportList, gameId } = props;
  return (
    <>
      {!selectedQuiz.finished && (
        <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
          <div style={{ display: "flex", flex: 3 }}>
            <QuizAdminGamePlayerMonitor question={selectedQuiz.question} imageUrl={selectedQuiz.imageUrl} />
          </div>
          <div style={{ display: "flex", flex: 1 }}>
            <QuizAdminGamePlayerExamList exams={selectedQuiz.exams || []} />
          </div>
        </div>
      )}
      {selectedQuiz.finished && (
        <QuizAdminGamePlayerQuizReportList items={selectedQuizReportList} />
      )}
      {gameReportList.length > 0 && (
        <QuizAdminGamePlayerGameReportList items={gameReportList} gameId={gameId} />
      )}
    </>
  );
};

const TimeLimitWrap = (props) => {
  const { selectedQuiz, onTimeout, solvedUserList } = props;
  return (
    <>
      <div style={{ marginTop: 30 }}>
        <div style={{ minHeight: 60 }}>
          {selectedQuiz.quizId && !selectedQuiz.finished && (<TimeLimit timeLimit={selectedQuiz.timeLimit} onTimeout={onTimeout} />)}
        </div>
      </div>
      <div style={{ marginTop: 10 }}>
        {solvedUserList.length > 0 && (<>{solvedUserList.length}명 완료!</>)}
      </div>
    </>
  );
};

const QuizPlayControllerWrap = (props) => {
  const { onClickNext, onClickEnd, onClickGameResult } = props;
  return (
    <>
      <div style={{ marginTop: 10 }}>
        <button style={{ minWidth: 100 }} className={"btn btn-primary"} onClick={onClickNext}>다음</button>
      </div>
      <div style={{ marginTop: 10 }}>
        <button style={{ minWidth: 100 }} className={"btn btn-danger"} onClick={onClickEnd}>종료</button>
      </div>
      <div style={{ marginTop: 10 }}>
        <button style={{ minWidth: 100 }} className={"btn btn-info"} onClick={onClickGameResult}>순위</button>
      </div>
    </>
  );
};

class TimeLimit extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      remain: props.timeLimit
    };
    this.interval = undefined;
  }

  componentDidMount() {
    const DELAY = 100;
    this.interval = setInterval(() => {
      const _remain = this.state.remain;
      const remainNext = (_remain - DELAY);
      if (_remain > 0 && remainNext === 0)
        this.props.onTimeout && this.props.onTimeout();

      this.setState({ remain: remainNext });
    }, DELAY);
  }

  componentWillUnmount() {
    this.interval && clearInterval(this.interval);
  }

  render() {
    return (
      <>
        {this.state.remain > 0 && (<TimeLimitBar current={this.state.remain} max={this.props.timeLimit} />)}
        {this.state.remain > 0 && (<MsToString style={{ fontSize: 24, fontFamily: "monospace" }} ms={this.state.remain} />)}
      </>
    );
  }
}

const TimeLimitBar = (props) => {
  const { current, max } = props;
  const percent = ((current / max) * 100).toFixed(3);
  return (
    <div className="progress" style={{ marginLeft: 10, marginRight: 10, background: "#ccc" }}>
      <div
        className="progress-bar"
        role="progressbar"
        style={{ width: `${percent}%` }}
        aria-valuenow="25"
        aria-valuemin="0"
        aria-valuemax="100" />
    </div>
  );
};

const QuizAdminGamePlayerQuizSimpleList = (props) => {
  const { items, selectedQuiz } = props;
  return (
    <div>
      {items.map((item, idx) => {
        const solved = (item.solved === true);
        const current = (item.id === selectedQuiz.quizId);
        const solvedStyle = { color: "#aaa" };
        const currentStyle = { fontWeight: "bold" };
        return (
          <div key={idx} style={current ? currentStyle : solved ? solvedStyle : {}}>{idx + 1}. {item.category}({item.score})</div>
        );
      })}
    </div>
  );
};

const QuizAdminGamePlayerJoinedUserList = (props) => {
  const { items, user } = props;
  return (
    <div>
      {items.map((item, idx) => (
        <div key={idx} style={{ color: (item.userId === user.id) ? "#aaa" : "#000" }}>{item.userNickname}</div>
      ))}
    </div>
  );
};

const QuizAdminGamePlayerQuizReportList = (props) => {
  const { items } = props;
  return (
    <div>
      <h1 style={{ marginTop: 30 }}>결과</h1>
      <table className={"table"}>
        <thead>
          <tr>
            <th style={{ width: "40%" }}>닉네임</th>
            <th style={{ width: "35%" }}>응답</th>
            <th style={{ width: "25%" }}>점수</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item, idx) => (
            <tr key={idx} style={{ fontSize: 28 }}>
              <td>{item.userNickname}</td>
              <td style={{ color: (item.correct ? "blue" : "red") }}>{item.answer}</td>
              <td>{item.score}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const QuizAdminGamePlayerGameReportList = (props) => {
  const { items, gameId } = props;

  const onClickDelete = (e) => {
    e.preventDefault();
    const { userid } = e.currentTarget.dataset;
    const answer = window.confirm("Are you sure?");
    if (answer) {
      repository.leaveGameUser({ id: gameId, userId: userid });
    }
  };

  return (
    <div>
      <h1 style={{ marginTop: 30 }}>순위</h1>
      <table className={"table"}>
        <thead>
          <tr>
            <th style={{ width: "10%" }}>순위</th>
            <th style={{ width: "30%" }}>닉네임</th>
            <th style={{ width: "35%" }}>총점</th>
            <th style={{ width: "25%" }}>정답 수</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item, idx) => (
            <tr key={idx} style={{ fontSize: 28 }}>
              <td>{idx + 1}위</td>
              <td>
                {item.userNickname}
                &nbsp;<a href={"/"} data-userid={item.userId} onClick={onClickDelete}>
                  <i className={"bi-dash-circle-fill"}></i>
                </a>
              </td>
              <td>{item.totalScore}점</td>
              <td>{item.correctCount}개</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const QuizAdminGamePlayerMonitor = (props) => {
  const { question, imageUrl } = props;
  return (
    <div style={{
      display: "flex",
      width: "100%",
      flexDirection: "column",
      justifyContent: imageUrl ? "flex-end" : "center",
      backgroundColor: imageUrl ? "#000" : "#fff",
      backgroundSize: "contain",
      backgroundPosition: "50% 50%",
      backgroundRepeat: "no-repeat",
      backgroundImage: `url(${imageUrl})`
    }}>
      {question && (
        <div style={{
          fontSize: 42,
          padding: 10,
          background: "rgba(0,0,0,0.8)",
          textAlign: "left",
          color: "#fff"
        }}>{question}</div>
      )}
    </div>
  );
};

const QuizAdminGamePlayerExamList = (props) => {
  const { exams } = props;
  return (
    <div style={{ display: "flex", width: "100%", flexWrap: "wrap" }}>
      {exams && exams.length > 1 && exams.map((item, idx) => (
        <QuizAdminGamePlayerExamItem key={idx} idx={idx} item={item} />
      ))}
    </div>
  );
};

const QuizAdminGamePlayerExamItem = (props) => {
  const { item, idx } = props;
  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      flex: "0 0 50%",
      justifyContent: "center",
      height: "50%",
      padding: 10,
    }}>
      <div style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        height: "100%",
        fontSize: 32,
        background: colors[idx],
        color: "#fff",
        borderRadius: 12
      }}>
        {item}
      </div>
    </div>
  );
};

export { QuizAdminGamePlayerPage };
